<template>
   <Container :list="this.$nav6" title="院系专业" v-if="isMaxScreen">
    <div class="zszy">
      <div class="breadcrumb">
        <router-link to="/" class="breadcrumb-item">
          首页
        </router-link>
        -
        <span class="breadcrumb-item">院系专业</span>
      </div>
      <div class="zsxx_bottom">
         <div class="zszy_box" v-for="(item, index) in list" :key="index">
           <div class="zszy_box_hearder" @click="toPage(item)">
              <div class="block"></div>
              <div class="zszy_hearder_left">
                 {{item.name}}
              </div>
              <!-- <div  class="zszy_hearder_right">
                 <span>查看</span>
                 <img src="@/assets/image/zszy01.png" alt="">
              </div> -->
           </div>
           <!-- <div class="zszy_box_zylist" @click="isPush(item1)" v-for="item1 in item.majors" :key="item1.id">
            {{item1.name}}
           </div> -->
         </div>
      </div>
    </div>
  </Container>

  <ZszyH5 v-else :list="list" />
</template>

<script>
import Container from '@/components/Container'
import ZszyH5 from '@/views/app/zszy/index'
export default {
  name: 'Zszy',
  components: { Container, ZszyH5 },
  props: {},
  data () {
    return {
      list: [],
      isMaxScreen: true
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getXueYuan()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {
    // isPush(item1) {
    //   this.$router.push({path: '/zyjs/zyjj?ids=0', query: {id: item1.id}})
    // },
    toPage (item) {
      this.$router.push({ path: '/zyjs/xyjj?ids=0', query: { id: item.id } })
      this.$store.commit('setSidebar', this.$nav7)
    },
    async getXueYuan () {
      const { data } = await this.$get('/ow/department')
      this.list = data
      console.log(data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .zszy {
    width: 890px;
    font-size: 16px;
    color: #333333;
      .zsxx_bottom {
        display: flex;
        flex-wrap: wrap;
        .zszy_box {
          width: 350px;
          margin-right: 14px;
          margin-bottom: 24px;
          cursor: pointer;
          .zszy_box_hearder {
            display: flex;
            align-items: center;
            padding: 0 10px;
            line-height: 48px;
            &:hover {
              color: #4E55AF;
            }
          }
        }
        .block {
          width: 8px;
          height: 8px;
          background: #4E55AF;
          margin-right: 10px;
        }
      }
    }
</style>
